import { useFilterCoursesByCollection } from '@/hooks/useFilterCoursesByCollection'
import { useQueryObjectiveAccessesQuery } from '@/store/api/aggregatesApi'
import { COLLECTION_NO_VALUE } from '@/store/api/showcasesApi'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { useGetCatalogCoursesFilter } from './useGetCatalogCoursesFilter'

export const useQueryCatalogCourses = () => {
  const coursesFilter = useGetCatalogCoursesFilter()
  const collectionFilters = useAppSelector((state) => createFiltersSelector(state, 'catalog').collection)

  const {
    data: { data: catalogCourses = [], totalCount: totalCatalogCourses = 0 } = {},
    isLoading: isCatalogCoursesLoading,
  } = useQueryObjectiveAccessesQuery(
    { query: { filter: coursesFilter } },
    {
      refetchOnMountOrArgChange: true,
    },
  )

  const filteredCatalogCourses = useFilterCoursesByCollection({ type: 'catalog', courses: catalogCourses })

  const uncategorizedCoursesCount = catalogCourses.filter((course) => !course.objective.showcases?.length).length
  const hasNoShowCase =
    collectionFilters.includes(COLLECTION_NO_VALUE) ||
    (uncategorizedCoursesCount > 0 && uncategorizedCoursesCount !== catalogCourses.length)

  return {
    catalogCourses: filteredCatalogCourses,
    totalCatalogCourses,
    isCatalogCoursesLoading,
    hasNoShowCase,
  }
}
